import tipsGeneral from '@/store/modules/tips/general';

export default {
  tipsGeneral,
};
